import { Select } from '@zoopla-eng/zds/select';

export type TransportType =
    | 'driving'
    | 'walking'
    | 'walking_train'
    | 'public_transport'
    | 'cycling';

const transportTypeOptions = new Map<TransportType, string>([
    ['driving', 'Driving'],
    ['walking', 'Walking'],
    ['walking_train', 'Train'],
    ['public_transport', 'Public transport'],
    ['cycling', 'Cycling']
]);

type SelectTransportModeProps = {
    value: TransportType;
    onChange: (transportType: TransportType) => void;
};

export const SelectTransportMode = ({
    value,
    onChange
}: SelectTransportModeProps) => {
    const options = Array.from(transportTypeOptions.keys()).map((value) => ({
        text: transportTypeOptions.get(value) ?? '',
        id: value
    }));

    return (
        <Select
            label="Transport mode"
            selectedOption={
                options.find((option) => option.id === value) ?? options[0]
            }
            onSelectedOptionChange={(e) => {
                onChange(e.id as TransportType);
            }}
            options={options}
        />
    );
};
